import { AlertTriangle } from "lucide-react";
import { Button } from "./ui/button";
import {
	Dialog,
	DialogClose,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "./ui/dialog";

export interface ConfirmDialogOptions {
	title: string;
	message: string;
	confirmLabel?: string;
	variant?: "danger" | "default";
}

interface ConfirmDialogProps extends ConfirmDialogOptions {
	open: boolean;
	onConfirm: () => void;
	onCancel: () => void;
	isPending?: boolean;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
	open,
	title,
	message,
	confirmLabel = "Confirm",
	variant = "default",
	onConfirm,
	onCancel,
	isPending = false,
}) => {
	return (
		<Dialog open={open} onOpenChange={(o) => !o && onCancel()}>
			<DialogContent>
				<DialogHeader>
					{variant === "danger" && (
						<AlertTriangle className="mb-2 h-10 w-10 text-(--color-error-500)" />
					)}
					<DialogTitle>{title}</DialogTitle>
				</DialogHeader>
				<DialogDescription>{message}</DialogDescription>
				<DialogFooter>
					<DialogClose asChild>
						<Button variant="outline" disabled={isPending}>
							Cancel
						</Button>
					</DialogClose>
					<Button
						variant={variant === "danger" ? "destructive" : "default"}
						onClick={onConfirm}
						disabled={isPending}
					>
						{isPending ? "Processing..." : confirmLabel}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};

export default ConfirmDialog;
